(() => {
  const PAGE_SIZE = 5;
  const ROOT_SELECTOR = '.wise-reviews-element';
  const COLUMNS_SELECTOR = '.wr-id-review-column';

  function updateControls(carousel, page, totalPages) {
    const previous = carousel.querySelector('[data-wise-carousel="previous"]');
    const next = carousel.querySelector('[data-wise-carousel="next"]');
    const status = carousel.querySelector('[data-wise-carousel="status"]');
    const track = carousel.querySelector('.skinsyrup-wise-reviews__track');

    track.style.transform = `translateX(-${page * 100}%)`;
    previous.disabled = page === 0;
    next.disabled = page === totalPages - 1;
    status.textContent = `${page + 1} / ${totalPages}`;
  }

  function buildCarousel(root) {
    if (root.querySelector('.skinsyrup-wise-reviews__carousel')) {
      root.classList.add('skinsyrup-wise-reviews--carousel-ready');
      return;
    }

    const columns = Array.from(root.querySelectorAll(COLUMNS_SELECTOR));
    const grid = columns[0] && columns[0].parentElement;
    if (!grid) return;

    const cards = columns.flatMap((column) => Array.from(column.children));
    if (!cards.length) return;

    const carousel = document.createElement('div');
    carousel.className = 'skinsyrup-wise-reviews__carousel';
    carousel.setAttribute('aria-label', 'Customer reviews');

    const viewport = document.createElement('div');
    viewport.className = 'skinsyrup-wise-reviews__viewport';

    const track = document.createElement('div');
    track.className = 'skinsyrup-wise-reviews__track';

    for (let index = 0; index < cards.length; index += PAGE_SIZE) {
      const page = document.createElement('div');
      page.className = 'skinsyrup-wise-reviews__page';
      page.setAttribute('role', 'group');
      page.setAttribute('aria-label', `Reviews ${index + 1} to ${Math.min(index + PAGE_SIZE, cards.length)}`);
      cards.slice(index, index + PAGE_SIZE).forEach((card) => {
        card.classList.add('skinsyrup-wise-reviews__card');
        page.append(card);
      });
      track.append(page);
    }

    viewport.append(track);
    carousel.append(viewport);

    if (track.children.length > 1) {
      const controls = document.createElement('div');
      controls.className = 'skinsyrup-wise-reviews__controls';

      const previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'skinsyrup-wise-reviews__button';
      previous.dataset.wiseCarousel = 'previous';
      previous.setAttribute('aria-label', 'Previous reviews');
      previous.title = 'Previous reviews';
      previous.textContent = '<';

      const status = document.createElement('span');
      status.className = 'skinsyrup-wise-reviews__status';
      status.dataset.wiseCarousel = 'status';
      status.setAttribute('aria-live', 'polite');

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'skinsyrup-wise-reviews__button';
      next.dataset.wiseCarousel = 'next';
      next.setAttribute('aria-label', 'Next reviews');
      next.title = 'Next reviews';
      next.textContent = '>';

      let page = 0;
      const totalPages = track.children.length;
      previous.addEventListener('click', () => {
        page = Math.max(0, page - 1);
        updateControls(carousel, page, totalPages);
      });
      next.addEventListener('click', () => {
        page = Math.min(totalPages - 1, page + 1);
        updateControls(carousel, page, totalPages);
      });

      controls.append(previous, status, next);
      carousel.append(controls);
      updateControls(carousel, page, totalPages);
    }

    grid.replaceChildren(carousel);
    root.classList.add('skinsyrup-wise-reviews--carousel-ready');
  }

  function initialise(root) {
    if (root.dataset.skinsyrupWiseReviewsInitialised === 'true') return;
    root.dataset.skinsyrupWiseReviewsInitialised = 'true';

    buildCarousel(root);
    const observer = new MutationObserver(() => {
      if (!root.querySelector('.skinsyrup-wise-reviews__carousel')) {
        root.classList.remove('skinsyrup-wise-reviews--carousel-ready');
        buildCarousel(root);
      } else {
        root.classList.add('skinsyrup-wise-reviews--carousel-ready');
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function start() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initialise);
  }

  function watchForLateWidgets() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(ROOT_SELECTOR)) initialise(node);
          node.querySelectorAll(ROOT_SELECTOR).forEach(initialise);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  watchForLateWidgets();
})();

